/** Region IDs for portal targets */
export const REGION_IDS = {
  headerLeft: "map-layout-header-left",
  headerRight: "map-layout-header-right",
  panel: "map-layout-panel",
  controls: "map-layout-controls",
  messages: "map-layout-messages",
} as const;

/** Internal region IDs - not part of public API */
export const INTERNAL_REGION_IDS = {
  panelMobile: "map-layout-panel-mobile",
} as const;
